import Component from './DynamicComponent'
import StoryblokClient from 'storyblok-js-client'
import SbEditable from 'storyblok-react'


const Storyblok = new StoryblokClient({
    accessToken: 'LZGFxjR34cofPNlwzU6wgwtt',
    cache: {
      clear: 'auto',
      type: 'memory'
    }
})
const TermText = ({ term }) => {

  return (
    <SbEditable content={term}>
    <div className="wrap-line"></div>
    </SbEditable>
  )
}

export default TermText;
